import { render, staticRenderFns } from "./Laboratory.vue?vue&type=template&id=d66bd5e0&scoped=true"
import script from "./Laboratory.vue?vue&type=script&lang=js"
export * from "./Laboratory.vue?vue&type=script&lang=js"
import style0 from "./Laboratory.vue?vue&type=style&index=0&id=d66bd5e0&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d66bd5e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/node-apps/im.ingenes.com/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d66bd5e0')) {
      api.createRecord('d66bd5e0', component.options)
    } else {
      api.reload('d66bd5e0', component.options)
    }
    module.hot.accept("./Laboratory.vue?vue&type=template&id=d66bd5e0&scoped=true", function () {
      api.rerender('d66bd5e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Proposal/Laboratory.vue"
export default component.exports